export enum ROLE {
  ADMIN = 1,
  SUBADMIN = 2,
}

export enum VENDOR_PROFILE_STEPS {
  PERSONAL = 1,
  BANK = 2,
  POLICIES = 3,
  SHIPPING = 4,
  RETURN = 5,
  BRANDING = 6,
  SUBSCRIPTION = 7,
}

export enum ORDER_STATUS {
  PENDING = 1,
  ACCEPT = 2,
  ONGOING = 3,
  COMPLETED = 4,
  CANCELLED = 5,
}
export const BOOKING_STATUS = {
  PENDING: 1,
  ACCEPTED: 2,
  ONGOING: 3,
  COMPLETED: 4,
  CANCELLED: 5,
  REJECTED: 6,
};
export enum LOGIN_MODAL_TYPE {
  SINGNUP = 1,
  LOGIN = 2,
  FORGOT_PASSWORD = 3,
  EMAIL = 4,
  Phone = 5,
}

export const enum OTP_TYPE {
  SINGNUP = 1,
  LOGIN = 2,
  FORGOT = 3,
  UPDATE = 4,
  STARTSELLING = 5,
}

export enum PRICE_TYPE {
  HOURLY = 1,
  FIXED = 2,
  PACKAGE = 3,
}
export enum COMMON_STATUS {
  PENDING = "1",
  APPROVED = "2",
  REJECTED = "3",
  PAID = "4",
  EXPIRED = "5",
  OVERDUE = "6",
  FAILED = "7",
  COMPLETED = "8",
  CANCELLED = "9",
  ONGOING = "10"
};
export const TICKETS_PRIORITY = {
  LOW: 1,
  MEDIUM: 2,
  HIGH: 3
}
export const PAYMENT_TYPE = {
  CASH: 1,
  ONLINE: 2,
  OTHER: 3,
};
export const PAYMENT_STATUS = {
  PAID: 1,
  PENDING: 2,
  FAILED: 3,
  REFUND_PROGRESS: 4,
  REFUNDED: 5,
  NON_REFUNDABLE: 6,
};

export const PAYMENT_METHOD = {
  CARD: 1,
  UPI: 2,
  CASH: 3,
};